export default __webpack_public_path__ + "static/media/Process_owner.a4e420e5.svg";